import { render, staticRenderFns } from "./templateA.vue?vue&type=template&id=e47eeeb8&scoped=true"
import script from "./templateA.vue?vue&type=script&lang=js"
export * from "./templateA.vue?vue&type=script&lang=js"
import style0 from "./templateA.vue?vue&type=style&index=0&id=e47eeeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47eeeb8",
  null
  
)

export default component.exports